import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import SantaRosaHeroSection from "./components/HeroSection";
import SantaRosaStickyNav from "./components/StickyNav";
import SantaRosaProcessingTimeSection from "./components/ProcessingTimeSection";
import SantaRosaServicesSection from "./components/ServicesSection";
import SantaRosaLocalAreaSection from "./components/LocalAreaSection";
import SantaRosaTravelTimingSection from "./components/TravelTimingSection";
import SantaRosaDestinationsSection from "./components/DestinationsSection";
import SantaRosaTestimonialsSection from "./components/TestimonialsSection";
import SantaRosaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SantaRosaComparisonSection from "./components/ComparisonSection";
import SantaRosaMistakesSection from "./components/MistakesSection";
import SantaRosaHowItWorksSection from "./components/HowItWorksSection";
import SantaRosaFAQSection, { faqs } from "./components/FAQSection";
import SantaRosaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SantaRosaFinalCTA from "./components/FinalCTA";

export default function SantaRosaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Santa Rosa"
        state="California"
        stateAbbr="CA"
        route="/santa-rosa"
        title="Emergency Passport Santa Rosa, CA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Santa Rosa, CA — as fast as 24 hours. Serving all of Sonoma County including Petaluma, Healdsburg, and Oakmont. A+ BBB rated, registered State Dept. courier. Best price guarantee."
        geoPlacename="Santa Rosa, California"
        geoPosition="38.4404;-122.7141"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="California"
        statePageRoute="/states/california"
      />
      <SantaRosaHeroSection />
      <SantaRosaStickyNav />
      <SantaRosaProcessingTimeSection />
      <SantaRosaServicesSection />
      <SantaRosaLocalAreaSection />
      <SantaRosaTravelTimingSection />
      <SantaRosaDestinationsSection />
      <SantaRosaTestimonialsSection />
      <SantaRosaAcceptanceFacilitiesSection />
      <SantaRosaComparisonSection />
      <SantaRosaMistakesSection />
      <SantaRosaHowItWorksSection />
      <SantaRosaFAQSection />
      <SantaRosaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/santa-rosa" state="CA" />
      <SantaRosaFinalCTA />
    </div>
  );
}